import { render } from "./AlurAlgoritmaKlinisForm.vue?vue&type=template&id=685eea2a&scoped=true"
import script from "./AlurAlgoritmaKlinisForm.vue?vue&type=script&lang=js"
export * from "./AlurAlgoritmaKlinisForm.vue?vue&type=script&lang=js"

import "./AlurAlgoritmaKlinisForm.vue?vue&type=style&index=0&id=685eea2a&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685eea2a"]])

export default __exports__